module.exports = __webpack_public_path__ + "static/media/loading.e30b73f3.svg";